window.debug = process.env.REACT_APP_ENV !== 'production';

export function logger(...rest: any[]): void {
  if (window.debug) {
    console.log(...rest);
  }
}
